export default __webpack_public_path__ + "static/media/Q42024.72fb05d4.pdf";